import type { SensitivityOrdinal } from '@dawn/feature-config';

/**
 * Five-stop warm ramp keyed by sensitivity ordinal (1 = least, 5 = most).
 * Used to colorize bars in the Access Discovery widget.
 */
export const SENSITIVITY_RAMP = {
  1: '#ffe593',
  2: '#ffca27',
  3: '#ffbb60',
  4: '#ff9700',
  5: '#f47600',
} as const satisfies Readonly<Record<SensitivityOrdinal, string>>;

export function getSensitivityRampColor(score: SensitivityOrdinal): string {
  return SENSITIVITY_RAMP[score];
}

/**
 * Warm-ramp palette matching the Figma Access Discovery design.
 * Maps left-column identity rows 0–9 to their exact Figma bar colors.
 */
export const IDENTITY_PALETTE: readonly string[] = [
  '#f47600', // Engineering / Customer Success
  '#ffca27', // Product / External
  '#ff9700', // Sales / Finance
  '#ffbb60', // Marketing | design / All Other
  '#ffe593', // HR / NHI — Figma canonical category.5 (#FFE593)
  '#f47600',
  '#ff9700',
  '#ffca27',
  '#ffe593',
  '#ffbb60',
] as const;

/**
 * Returns the palette color assigned to the row at the given index.
 * Color is positional (matches the Figma row-position assignments in
 * `IDENTITY_PALETTE`) and cycles via modulo when index >= palette length.
 */
export function getIdentityColor(index: number): string {
  return IDENTITY_PALETTE[index % IDENTITY_PALETTE.length] ?? IDENTITY_PALETTE[0]!;
}
